import React from 'react';
import './styles/Badge.css';

export const Badge = ({
  children,
  variant = 'primary',
  size = 'md',
  icon: Icon,
  className = '',
  ...props
}) => {
  const classes = `badge badge-${variant} badge-${size} ${className}`;
  
  return (
    <span className={classes} {...props}>
      {Icon && <Icon className="badge-icon" />}
      {children}
    </span>
  );
};

export default Badge;
